import cx from "classnames";
import {
  Footer,
  Header,
  SideMenu,
  FlexBox,
  DashboardSideMenu,
  Loader,
  OrganisationSelectionModal,
} from "components";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Slide, toast, ToastContainer } from "react-toastify";
import ROUTE_PATH from "Routes/paths";
import {
  AllApplicationsApi,
  GetUserDetailsApi,
  setGeneralDetails,
  useAllApplicationsApiDetails,
  useGeneralDetails,
  useGetUserDetailsApiDetails,
} from "Slices";
import { ChangeHistory, history } from "utils";
import "./styles.scss";
import { ScreenProps } from "./types";
let timeout: any = null;
const Screen: React.FC<ScreenProps> = ({
  preventSlide = false,
  className,
  children,
  hasSideMenu,
  hasHeader,
  screenAnimationClass,
  customSideMenuVisibility,
  customSideMenuCallback,
}) => {
  const dispatch = useDispatch();
  const [animationClass, setAnimationClass] = useState("");
  const [showScreen, setShowScreen] = useState(false);
  const [pullRightStart, setPullRightStart] = useState(0);
  const [pullRightMovement, setPullRightMovement] = useState(0);
  const [isMenuOpened, setIsMenuOpened] = useState(false);
  const [menuOpened, setMenuOpened] = useState(false);
  const [hasTimerClass, setHasTimerClass] = useState(false);

  //Slices
  const userDetails = useGetUserDetailsApiDetails();
  const allApplications = useAllApplicationsApiDetails();
  const generalDetails = useGeneralDetails();

  useEffect(() => {
    if (userDetails?.data?.organizations?.[0].id) {
      // getAllApplications(userDetails?.data);
    } else {
      dispatch(
        GetUserDetailsApi({
          callback: getAllApplications,
        })
      );
    }
  }, []);

  const getAllApplications = (userDetails) => {
    setGeneralDetails({
      selectedOrganisation:
        userDetails?.organizations?.[
          Number(localStorage.getItem("organisationIndex"))
        ],
    });
    dispatch(
      AllApplicationsApi({
        organizationId: localStorage.getItem("organisationID"),
        callback: setRouting,
      })
    );
  };

  const setRouting = (applicationList) => {
    applicationList?.length > 0
      ? ChangeHistory("push", ROUTE_PATH.DASHBOARD.ACTIVITY)
      : ChangeHistory("push", ROUTE_PATH.DASHBOARD.HOME);
  };

  useEffect(() => {
    timeout = setTimeout(() => {
      if (screenAnimationClass) {
        setAnimationClass(screenAnimationClass);
      } else if (generalDetails?.screenClass) {
        setAnimationClass(generalDetails?.screenClass);
      } else {
        switch (history.action) {
          case "PUSH":
            setAnimationClass("fadeInRight");
            break;

          case "POP":
            setAnimationClass("fadeInLeft");
            break;

          default:
            break;
        }
      }
      setShowScreen(true);
    }, 0);
    return () => {
      timeout = null;
    };
  }, [generalDetails, screenAnimationClass]);

  return (
    <>
      <div className="dashboard-screen">
        <ToastContainer
          position={toast.POSITION.TOP_RIGHT}
          autoClose={2500}
          hideProgressBar={true}
          closeButton={false}
          transition={Slide}
          draggable={false}
          pauseOnFocusLoss={false}
          closeOnClick={true}
          className="toaster"
          limit={1}
        />
        <DashboardSideMenu />
        <main className={cx(className, "pd-20")}>{children}</main>
      </div>
    </>
  );
};

export default Screen;
